// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"Paragraph_paragraph__2sRJi","lightTheme":"Paragraph_lightTheme__3on1u","darkTheme":"Paragraph_darkTheme__26j4O"};